import React from 'react';

function RegistrationTable({ registrations, loading, selectedEventId, onRefresh, onAction }) {
    if (loading) {
        return <div className="loader">FETCHING REGISTRATIONS...</div>;
    }

    return (
        <div className="fighter-list-admin">
            <div className="admin-header">
                <h3>REGISTRATIONS ({registrations.length})</h3>
                <button
                    type="button"
                    onClick={onRefresh}
                    className="refresh-btn"
                    disabled={!selectedEventId}
                >
                    ↻
                </button>
            </div>

            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Style</th>
                        <th>KG</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {registrations.map((r) => {
                        const displayName =
                            r.user?.profile?.displayName ||
                            r.user?.telegram?.firstName ||
                            'Unknown';

                        return (
                            <tr key={r._id}>
                                <td>{displayName}</td>
                                <td className="dim">{r.answers?.style || '-'}</td>
                                <td>{r.answers?.weight || '-'}</td>
                                <td>{String(r.status || '').replace('_', ' ')}</td>
                                <td>
                                    <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
                                        {r.status === 'pending' && (
                                            <>
                                                <button type="button" onClick={() => onAction(r._id, 'approved')}>
                                                    Approve
                                                </button>
                                                <button type="button" onClick={() => onAction(r._id, 'waitlisted')}>
                                                    Waitlist
                                                </button>
                                                <button type="button" onClick={() => onAction(r._id, 'rejected')}>
                                                    Reject
                                                </button>
                                            </>
                                        )}

                                        {r.status === 'approved' && (
                                            <>
                                                <button type="button" onClick={() => onAction(r._id, 'checked_in')}>
                                                    Check In
                                                </button>
                                                <button type="button" onClick={() => onAction(r._id, 'waitlisted')}>
                                                    Waitlist
                                                </button>
                                                <button type="button" onClick={() => onAction(r._id, 'cancelled')}>
                                                    Cancel
                                                </button>
                                            </>
                                        )}

                                        {r.status === 'waitlisted' && (
                                            <>
                                                <button type="button" onClick={() => onAction(r._id, 'approved')}>
                                                    Approve
                                                </button>
                                                <button type="button" onClick={() => onAction(r._id, 'rejected')}>
                                                    Reject
                                                </button>
                                                <button type="button" onClick={() => onAction(r._id, 'cancelled')}>
                                                    Cancel
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default RegistrationTable;